import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const MOVE_FORM_REQUEST = 'MOVE_FORM_REQUEST';
export const MOVE_FORM_SUCCESS = 'MOVE_FORM_SUCCESS';
export const MOVE_FORM_FAILURE = 'MOVE_FORM_FAILURE';

function request() {
  return {
    type: MOVE_FORM_REQUEST
  };
}

function receive() {
  return {
    type: MOVE_FORM_SUCCESS
  };
}

function reject() {
  return {
    type: MOVE_FORM_FAILURE
  };
}

export function moveForm(formId, sourceCustomerId, sourceAccountId, customerId, accountId, onSuccess, deleteCollectableSupportingDocs) {
  return (dispatch) => {
    dispatch(request(formId));

    const promise = () => ApiService
      .moveForm(formId, sourceCustomerId, sourceAccountId, customerId, accountId, deleteCollectableSupportingDocs)
      .then((response) => {
        dispatch(receive());
        toastr.success('Success', 'Form moved successfully');
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true));
        }
      });
    return promise();
  };
}
